/* eslint no-param-reassign:  ["error", { "props": false }] */
/* eslint no-shadow: 0 */
import {
  SHOW_GALLERY,
  SET_IMAGES,
  SET_ACTIVE_IMAGE,
} from '@/store/mutation-types';

const state = {
  images: [],
  active: 0,
  show: false,
};


const getters = {
  images(state) { return state.images; },
  active(state) { return state.active; },
  show(state) { return state.show; },
};


const actions = {
  setImages({ commit }, images) {
    commit(SET_IMAGES, images);
  },
  setActiveImage({ commit }, index) {
    commit(SET_ACTIVE_IMAGE, index);
  },
  showGallery({ commit }, values) {
    commit(SHOW_GALLERY, values);
  },
  hideGallery({ commit }) {
    commit(SHOW_GALLERY, { show: false });
  },
};


const mutations = {
  [SET_IMAGES](state, images) {
    state.images = images;
  },
  [SET_ACTIVE_IMAGE](state, index) {
    state.active = index;
  },
  [SHOW_GALLERY](state, { show, active }) {
    state.show = show;
    state.active = active || 0;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/gallery.js